// extracted by mini-css-extract-plugin
module.exports =  {"wcInjuryContainer":"InjuryPage_wcInjuryContainer__mS0CJ","wcInjuryDetail":"InjuryPage_wcInjuryDetail__rL4YZ","wcAddInjuryDeleteIcon":"InjuryPage_wcAddInjuryDeleteIcon__5vjou"};